<div class="show-security-usage-warning-container">

  <div mat-dialog-title>This security cannot be added to a group<button class="close" mat-button data-cancel-button title="Cancel" (click)="close()"><i class="material-icons clear">clear</i>
</button></div>
<mat-dialog-content>
  @if (data && !isUnitTest) {
    <div class="header-message" [innerText]=getHeaderMessage()></div>
    <div>If you continue, these other security record(s) will be affected as described below:</div>
    @if (isLoading) {
      <div class="loading-spinner" data-loading-spinner></div>
    }
    <mat-table [ngClass]="{'hide': isLoading}" matSort data-audit-table [dataSource]="gridData$">
      <ng-container cdkColumnDef="securitySymb">
        <mat-header-cell *matHeaderCellDef data-symbol-sort mat-sort-header>{{columnHeaders[0]}}:</mat-header-cell>
        <mat-cell data-symbol *matCellDef="let row" [innerText]="row.securitySymb"></mat-cell>
      </ng-container>
      <ng-container cdkColumnDef="noLongerBe">
        <mat-header-cell *matHeaderCellDef data-original-trade-sort mat-sort-header>{{columnHeaders[1]}}:</mat-header-cell>
        <mat-cell data-original-trade *matCellDef="let row" [innerText]="row.relatedAs"></mat-cell>
      </ng-container>
      <ng-container cdkColumnDef="forThisOther">
        <mat-header-cell *matHeaderCellDef data-modified-trade-sort mat-sort-header>{{columnHeaders[2]}}:</mat-header-cell>
        <mat-cell data-modified-trade *matCellDef="let row" [innerText]="row.relatedToName"></mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="columns; sticky: true"></mat-header-row>
      <mat-row data-audit-table-row *matRowDef="let row; columns: columns"></mat-row>
    </mat-table>
  }
  <button (click)="export()" class="btn-medium-secondary export-btn">Export</button>
</mat-dialog-content>
<mat-dialog-actions>
  <button data-close-button (click)="close()" [ngClass]="data ? 'btn-medium-secondary' : 'btn-medium-primary'">Close
  </button>
  <button data-export-button (click)="continue()" class="btn-medium-primary">Continue</button>
</mat-dialog-actions>
</div>
